import { CreditCardOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { Button, Descriptions, Popover, Spin, theme } from 'antd';
import { queryUserUsage } from '../api';

export const UsageButton = () => {
  return (
    <Popover
      classNames={{ content: 'w-64' }}
      placement="bottom"
      title="信用点详情"
      content={<UsageDescriptions></UsageDescriptions>}
      destroyOnHidden
    >
      <Button icon={<CreditCardOutlined />} variant="filled" color="default">
        信用点
      </Button>
    </Popover>
  );
};

export const UsageDescriptions = () => {
  const { data, isLoading } = useQuery(queryUserUsage);
  const { token } = theme.useToken();

  const credit = data?.credit ?? 0;
  const used = data?.used ?? 0;
  const remaining = data?.remaining ?? 0;

  // 额度有限且已用完时标红提示
  const exhausted = credit > 0 && remaining === 0;

  return (
    <Spin spinning={isLoading}>
      <Descriptions
        size="small"
        bordered
        column={1}
        items={[
          {
            key: 'key',
            label: '换算',
            children: '1信用点 = 0.1元',
          },
          {
            key: 'credit',
            label: '每日额度',
            children: credit === -1 ? '无限' : credit,
          },
          {
            key: 'used',
            label: '今日已用',
            children: used,
          },
          {
            key: 'remaining',
            label: '剩余',
            children: (
              <span
                style={{ color: exhausted ? token.colorErrorText : void 0 }}
              >
                {remaining === -1 ? '无限' : remaining}
              </span>
            ),
          },
        ]}
      />
    </Spin>
  );
};
